export default {
  ENV: 'prod',
  VERSION: '2024-04-23_2100'
};
